<!--
  Everything lives inside this one `@if`. When the admin flag is off — or when
  the service gave us nothing — the band emits no element at all, so the
  homepage has no gap where it used to be. Do NOT swap this for a hidden
  wrapper.
-->
@if (show) {
  <section class="ia-band" aria-labelledby="ia-band-title">
    <div class="ia-band__inner">
      <div class="ia-band__head">
        <div class="ia-band__headings">
          <p class="ia-band__eyebrow">
            {{ "international_auctions.eyebrow" | translate }}
          </p>
          <h2 class="ia-band__title" id="ia-band-title">
            {{ "international_auctions.title" | translate }}
          </h2>
          <p class="ia-band__standfirst">
            {{ "international_auctions.standfirst" | translate }}
          </p>
        </div>

        <a
          class="ia-band__viewall"
          [routerLink]="'/international-auctions' | localeLink"
        >
          <span>{{ "international_auctions.view_all" | translate }}</span>
          <span class="ia-band__arrow" aria-hidden="true">&#8594;</span>
        </a>
      </div>

      <!-- "3 auctions live now · 4 more upcoming" -->
      <p class="ia-band__counter">
        <span class="ia-band__dot" aria-hidden="true"></span>
        <span class="ia-band__live">{{
          liveCounterKey | translate: { count: liveCount }
        }}</span>
        @if (upcomingCount > 0) {
          <span class="ia-band__upcoming">
            <span aria-hidden="true">&#183;</span>
            <span>{{
              "international_auctions.counter.more_upcoming"
                | translate: { count: upcomingCount }
            }}</span>
          </span>
        }
      </p>

      <!--
        Horizontal rail. `tabindex` because a scroll container that only
        responds to a mouse wheel is unreachable by keyboard. The card owns its
        own width and `scroll-snap-align`; this element only decides whether
        snapping is on (it is, below 900px).
      -->
      <div class="ia-band__rail" tabindex="0" aria-labelledby="ia-band-title">
        @for (sale of sales; track sale.id) {
          <app-international-sale-card
            [sale]="sale"
            variant="rail"
            [showType]="false"
          ></app-international-sale-card>
        }
      </div>

      <p class="ia-band__disclaimer">
        <span class="ia-band__x" aria-hidden="true">&#10005;</span>
        <span>{{ "international_auctions.disclaimer" | translate }}</span>
      </p>
    </div>
  </section>
}
